import { useCallback, useContext } from 'react';
import { NotificationContext } from './NotificationProvider';
import { ShowFn, Options } from './types';

const useNotifications = () => {
  const ctx = useContext(NotificationContext);

  if (!ctx) {
    throw Error('The `useNotifications` hook must be called from a descendent of the `NotificationProvider`.');
  }

  const showSuccessNotification = useCallback<ShowFn>((title, description, options ) =>
    ctx.show(title, description, {...options, type: 'success'}),
    [ctx.show]);

  const showErrorNotification = useCallback<ShowFn>((title, description, options ) =>
    ctx.show(title, description, {...options, type: 'error'}),
    [ctx.show]);

  return {
    showNotification: ctx.show,
    showSuccessNotification,
    showErrorNotification,
    hideNotification: ctx.hide,
    hideAllNotifications: ctx.hideAll,
    updateNotification: ctx.update,
    // notificationsStack: ctx.notifications,
  };
};


export default useNotifications;
